import request from './request'
//获取个人信息
export function reqPersonalData(data) {
  return request({
      url: 'myinfo',
      method: 'post',
      data
  })
}